(function($){
    $(document).ready(function(){
        if($('.qodef-woo-login-form-tagline').length > 0){
            $('.qodef-woo-login-form-tagline').html('Miody Suszka');
        }
    })
})(jQuery)